import styled from '@emotion/styled';

export const ActionsContainer = styled.div`
    display: flex;
    gap: 12px;
`;
